<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddService</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>
      <form [formGroup]="addServiceForm" (ngSubmit)="AddService()">
        <div class=" scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="form-row">
                <div class="col-lg-6 col-xl-3 af-form-group">
                  <label for="serviceNo" translate>lblServiceNumber<strong class="mlt6 required"> * </strong> </label>
                  <div class="lbl-info">
                    <input formControlName="serviceNo" class="form-control mb-2" maxlength="39"
                      [value]="cpf.serviceNo.value?.toUpperCase()"
                      [ngClass]="{'is-invalid': cpf.serviceNo.invalid && cpf.serviceNo.touched}">
                    <div *ngIf="cpf.serviceNo.touched && (cpf.serviceNo.errors?.required)"
                      class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      lblServiceNumberRequired
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row" *ngIf="t">
                <div class="col-lg-6 col-xl-3" *ngFor="let ticket of t.controls; let i = index">
                  <div [formGroup]="ticket">
                    <div class="af-form-group">
                      <label for="name"><span translate>lblName</span><span> in
                          {{languageList[i].value}}</span>
                        <strong class="mlt6 required"> * </strong> </label>
                      <div class="lbl-info">
                        <input formControlName="name" class="form-control mb-2" maxlength="30"
                          [ngClass]="{'is-invalid': cpf.service.invalid && cpf.service.touched}">
                        <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                          class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                            aria-hidden="true"></em>
                          lblNameRequired
                        </div>
                      </div>
                    </div>
                    
                    <div class="af-form-group" style="display: none;">
                      <label for="languageId" translate>Language Id</label>
                      <div class="lbl-info">
                        <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                          maxlength="30">
                      </div>
                    </div>

                    <div class="af-form-group">
                      <label for="description"><span translate>lblDescription</span><span> in
                          {{languageList[i].value}}</span>
                        <strong class="mlt6 required"> * </strong> </label>
                      <div class='lbl-info'>
                        <input formControlName="description" class="form-control mb-2" maxlength="200"
                          [ngClass]="{'is-invalid': cpf.service.invalid && cpf.service.touched}">
                        <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                          class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                            aria-hidden="true"></em>
                          lblDescriptionIsRequired
                        </div>
                      </div>
                    </div>
                    <div class="af-form-group">
                      <label for="internaldescription"><span translate>lblInternalDescription</span><span> in
                          {{languageList[i].value}}</span>
                        <strong class="mlt6 required"> * </strong> </label>
                      <div class="lbl-info">
                        <textarea formControlName="internaldescription" class="form-control mb-2" maxlength="1000"
                          [ngClass]="{'is-invalid': cpf.service.invalid && cpf.service.touched}"></textarea>
                        <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                          class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                            aria-hidden="true"></em>
                            lblInternalDescriptionIsRequired
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- External Link -->
                <div class="col-xl-6 af-form-group">
                  <label for="logo" translate>lblServiceExternalLink</label>
                  <div class='lbl-info'>
                    <ng-container>
                      <textarea ngxTrumbowygEditor class="form-control" formControlName="serviceExternalink"></textarea>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="form-row">

                <!--duration-->
                <div class="col-lg-6 col-xl-2 af-form-group">
                  <label for="service" translate>
                    <span translate>lblDuration</span>
                    <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <input placeholder="hh:mm" formControlName="duration" class="form-control mb-2"
                      pattern="^\d{2}:\d{2}$" maxlength="5" required (keypress)="isDigit($event)"
                      (input)="CheckDuration($event)">
                    <div *ngIf="cpf.duration.touched && (cpf.duration.errors?.required)"
                      class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      lblDurationRequired
                    </div>
                    <div *ngIf="cpf.duration.touched && (cpf.duration.errors?.pattern)"
                      class="help-block mt-1 text-danger" translate>
                      lblInvalidDuration
                    </div>
                  </div>
                </div>

                  
                <!-- Price -->
                <div class="col-lg-6 col-xl-2 af-form-group">
                  <label for="service" translate>lblPrice<span class="text-sm1" translate>lblExclVat</span>
                    <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <input formControlName="price" class="form-control mb-2" maxlength="10" required
                      [ngModel]="price | number: '1.2-2'" pattern="^[\d,.\s]+$" (blur)="onBlur($event)">
                    <div *ngIf="cpf.price.touched && (cpf.price.errors?.required)" class="help-block mt-1 text-danger"
                      translate>
                      lblPriceRequired
                    </div>
                    <div *ngIf="cpf.price.touched && (cpf.price.errors?.pattern)" class="help-block mt-1 text-danger"
                      translate>
                      lblOnlyNumbersAreAllowed
                    </div>
                  </div>
                </div>

                
                <!-- PriceInclVAT -->
                <div class="col-lg-6 col-xl-2 af-form-group">
                  <label for="service" translate>lblPrice <span class="text-sm1" translate>lblInclVAT</span>
                    <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <input formControlName="priceInclVAT" class="form-control mb-2"
                      [ngModel]="priceInclVAT|number: '1.2-2'"  disabled >
                  </div>
                </div>



                <!--Order Number-->
                <div class="col-lg-6 col-xl-1 af-form-group">
                  <label for="service" translate>lblOrderNumber
                  </label>
                  <div class='lbl-info'>
                    <input formControlName="OrderNumber" class="form-control mb-2" pattern="^[0-9]*$" maxlength="8"
                      (keypress)="isDigit($event)">
                    <div *ngIf="cpf.price.touched && (cpf.price.errors?.pattern)" class="help-block mt-1 text-danger"
                      translate>
                      lblOnlyNumbersAreAllowed
                    </div>
                  </div>
                </div>

                <!--logo-->
                <div class="col-lg-6 col-xl-3 af-form-group">
                  <label for="logo" translate>lblLogo</label>
                  <div class='lbl-info d-flex align-items-center'>
                    <ng-container *ngIf="image; ">
                      <div class="border mb-3 p-1 d-inline-block mr-3">
                        <img [src]="image | safe:'url' " id="UploadImage"
                          onError="this.onerror=null; this.src='../../../../assets/images/no-image-icon.png'"
                          width="50px" alt="">
                      </div>
                    </ng-container>
                    <div>
                      <span>
                        <label class="btn btn-outline-primary d-inline-block " for="select-files"
                          translate>lblUploadLogo</label>
                        <input type="file" id="select-files" formcontrolName="Image" hidden name="FUImage"
                          accept=".png, .jpg, .jpeg, .svg" (change)="onChangeFileUpload($event.target.files)">
                      </span>
                      <span class="ml-2">
                        <button type="button" class="btn btn-outline-primary d-inline-block" translate
                          (click)="RemoveLogo()">lblRemoveLogo</button>
                      </span>
                      <p class="text-muted">
                        <small translate>lblAllowedJPGPNGSVG</small>
                      </p>
                    </div>
                  </div>
                </div>
                <!--Category Name-->
                <div class="col-lg-6 col-xl-3 af-form-group">
                  <label for="serviceCategoryId" translate>lblCategoryName <strong class="mlt6 required"> *
                    </strong></label>
                  <div class='lbl-info'>
                    <select class="form-control mb-2" formControlName="serviceCategoryId"
                      [class.in-invalid]="cpf.isvalid && cpf.touched" required>
                      <option selected disabled [ngValue]="null" translate>lblSelectCategoryName</option>
                      <option *ngFor="let category of categoryList" [(ngValue)]="category.id">
                        {{category.service}}
                      </option>
                    </select>
                    <div *ngIf="cpf.touched" class="help-block text-danger"><span
                        translate>lblPleaseSelectServiceCategory</span>
                    </div>
                  </div>
                </div>

                <!-- Competence -->
                <div class="col-lg-6 col-xl-3 af-form-group">
                  <label for="competenceId" translate>lblCompetenceName <strong class="mlt6 required"> *
                    </strong></label>
                  <div class='lbl-info'>
                    <select class="form-control mb-2" formControlName="competenceId"
                      [class.in-invalid]="cpf.isvalid && cpf.touched" required>
                      <option selected disabled [ngValue]="null" translate>lblSelectCompetenceName</option>
                      <option *ngFor="let competence of competenceActiveList" [(ngValue)]="competence.id">
                        {{competence.name}}
                      </option>
                    </select>
                    <div *ngIf="cpf.touched" class="help-block text-danger"><span
                        translate>lblPleaseSelectCompetence</span>
                    </div>
                  </div>
                </div>
                <!-- Special tool -->
                <div class="col-md-6 col-xl-3 af-form-group" *ngIf="this.showspecialtool">
                  <label for="service" translate>lblSpecialToolTypesvc</label>
                  <div class="lbl-info">
                    <ng-select formControlName="specialToolTypeId"
                      placeholder="{{ 'lblSelectSpecialToolType' | translate }}">
                      <ng-template ng-header-tmp>
                        <span class="mbold" translate>lblSelectSpecialToolTypesvc</span>
                      </ng-template>
                      <ng-option *ngFor="let item of specialToolTypes" [value]="item.id">
                        <span>{{item.name}}</span>
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
                <div class=" col-lg-6 col-xl-3 af-form-group">
                  <label for="template-make" translate>lblChargingGroup</label>
                  <div class='lbl-info'>
                    <ng-select formControlName="chargingGroup" placeholder="{{ 'lblSelectChargingGroup' | translate }}" required
                      [(ngModel)]="chargingGroup">
                      <ng-template ng-header-tmp>
                        <span class="mbold w-66px" translate>lblCode</span>
                        <span class="mbold" translate>lblName</span>
                      </ng-template>
                
                      <ng-option *ngFor="let type of chargingGroupList" [value]="type.groupNo">
                        <span class="w-66px">{{type.groupNo}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                        <span>{{type.charginGroupName}}</span>
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
                <!-- DmsServiceId  -->
                <div class="col-lg-3 col-xl-3 af-form-group" *ngIf="this.dmsServiceId">
                  <label for="service" translate>lblDmsServiceId</label>
                  <div class='lbl-info'>
                    <input formControlName="dmsServiceId" class="form-control mb-2">
                  </div>
                </div>
                <div class="col-lg-6 col-xl-6 af-form-group">
                  <div class="border p-3">
                    <label for="thisservice" translate>lblOptionalService</label>
                    <div class='lbl-info'>
                      <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="allServices"
                        (ngModelChange)="onChildServiceSelected($event)" [(ngModel)]="selectedChildServices"
                        [ngModelOptions]="{standalone: true}">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-6 af-form-group">
                  <div class="border p-3">
                    <span for="thisservice" translate>lblAfxPackage  </span> (<span class="lbl-info" style="color: red;" translate>lblPackageWithoutServices</span>)
                    <div class='lbl-info'>
                      <ng-select formControlName="packageNo" placeholder="{{ 'lblSelectPackage' | translate }}"
                        [(ngModel)]="selectPackage">
                        <ng-template ng-header-tmp>
                          <span class="mbold w-66px" translate>lblMakeCode</span>
                          <span class="mbold w-66px" translate>lblPackageNumber</span>
                          <span class="mbold" translate>lblVersionNumber</span>
                        </ng-template>

                        <ng-option *ngFor="let item of packageDropdownList" [value]="item.selectPackage">
                          <span class="w-66px">{{item.makeCode}}</span>
                          <span class="mx-2 hide-ng-dropdown-panel">-</span>
                          <span class="w-66px">{{item.packageNo}}</span>
                          <span class="mx-2 hide-ng-dropdown-panel">-</span>
                          <span>{{item.packageVersionNo}}</span>
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="col-12 pt-3">
                  <div class="row">
                    <div class="col-auto">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="isActive"
                          [checked]="addServiceForm.value.isActive" (change)="onChangeIsActive($event)">
                        <label class="custom-control-label" for="isActive">
                          <span translate>lblActive</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="displayInWidget"
                          [checked]="addServiceForm.value.displayInWidget" (change)="onChangedisplayInWidget(addServiceForm.value.displayInWidget)">
                        <label class="custom-control-label" for="displayInWidget">
                          <span translate>lblDisplayInWidget</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="displayPriceInWidget"
                          [disabled]="!addServiceForm.value.displayInWidget"
                          [checked]="addServiceForm.value.displayPriceInWidget"
                          (change)="onChangedisplayPriceInWidget(addServiceForm.value.displayPriceInWidget)">
                        <label class="custom-control-label" for="displayPriceInWidget">
                          <span translate>lblDisplayPriceInWidget</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="isFixed"
                          [checked]="addServiceForm.value.isFixed" (change)="onChangeIsFixed(addServiceForm.value.isFixed)">
                        <label class="custom-control-label" for="isFixed">
                          <span translate>lblIsFixed</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="needAttention"
                          [checked]="addServiceForm.value.needAttention" (change)="onChangeNeedAttention($event)">
                        <label class="custom-control-label" for="needAttention">
                          <span translate>lblNeedAttention</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="recommendedService"
                          [checked]="addServiceForm.value.recommendedService"
                          (change)="onChangeRecommendedService($event)">
                        <label class="custom-control-label" for="recommendedService">
                          <span translate>lblRecommendedService</span>
                        </label>
                      </div>
                    </div>
                    <div *ngIf="isWarningLightFeature">
                      <div class="col-auto">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="isWarningLight"
                            [checked]="addServiceForm.value.isWarningLight"
                            (change)="onChangeIsWarningLight(addServiceForm.value.isWarningLight)">
                          <label class="custom-control-label" for="isWarningLight">
                            <span translate>lblWarningLight</span>
                          </label>
                        </div>
                      </div>

                      <div class="col-lg-3 col-xl-3 af-form-group" *ngIf="addServiceForm.value.isWarningLight">
                        <label for="warningLight" translate>lblWarningLightName<strong class="mlt6 required"> *
                          </strong></label>
                        <div class='lbl-info'>

                          <ng-multiselect-dropdown [settings]="dropdownSettingsWarningLight" [data]="allWarningLight"
                            (ngModelChange)="onWarningLightSelected($event)" [(ngModel)]="selectedWarningLight"
                            [ngModelOptions]="{standalone: true}">
                          </ng-multiselect-dropdown>

                        </div>
                      </div>
                    </div>


                  </div>
                </div>



                <div class="form-row">
                  <div class="col-auto">
                    <div class="col af-form-group mt-4 mb-0">
                      <div class="form-check mt-2">
                        <input class="form-check-input" [(ngModel)]="addServiceForm.value.isAdditionalCustomerComment"
                          formControlName="isAdditionalCustomerComment" type="checkbox" value="" id="isCustomerComment">
                        <label class="form-check-label" for="isCustomerComment" translate>
                          lblAdditionalCustomerComment
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">

                  <div class="form-row mt-4" *ngIf="addServiceForm.value.isAdditionalCustomerComment && c">
                    <div class="col-lg-6 col-xl-3 af-form-group" *ngFor="let ticket of c.controls; let i = index">
                      <div [formGroup]="ticket">
                        <div class="af-form-group">
                          <label for="name"><span translate>lblAdditionalCustomerCommentTextBoxLabel</span><span> in
                              {{languageList[i].value}}</span>
                            <strong class="mlt6 required"> * </strong> </label>
                          <div class="lbl-info">
                            <input formControlName="name" class="form-control mb-2" maxlength="100"
                              [ngClass]="{'is-invalid': cpf.additionalCustomerComment.invalid && cpf.additionalCustomerComment.touched}">
                            <div
                              *ngIf="cpf.additionalCustomerComment.touched && (cpf.additionalCustomerComment.errors?.required)"
                              class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                                aria-hidden="true"></em>
                              lblNameRequired
                            </div>
                          </div>
                        </div>

                        <div class="af-form-group" style="display: none;">
                          <label for="languageId" translate>Language Id</label>
                          <div class="lbl-info">
                            <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                              maxlength="30">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="col-12">


                  <div class="mt-4 ctm-tab custom-card card-accord">
                    <ngb-accordion #a="ngbAccordion" activeIds="ngb-panel-0" class="overflow-none-card">
                      <ngb-panel title="first">
                        <ng-template ngbPanelHeader class="custom-header ctm">
                          <div class="d-flex align-items-center">
                            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
                              aria-label="Center Align" translate>
                              lblDurationAndPriceForServiceBooking
                              <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                  class="fas fa-angle-down fa-lg ml-auto"></em>
                              </ng-container>
                              <ng-container *ngIf="a.activeIds.includes('first')"><em
                                  class="fas fa-angle-up fa-lg ml-auto"></em>
                              </ng-container>
                            </button>
                          </div>
                        </ng-template>
                        <ng-template ngbPanelContent>


                              <div *ngFor="let serviceFilter of ServiceFilterForm; let in=index;let last=last">
                                <app-service-duration-price [in]=in [service]="serviceDetails"
                                [serviceFilter]="serviceFilter" [isAddView]="isAddView"
                                (addServiceTimeDetailSlotOpt)="AddServiceFilter($event)"
                                (removeServiceTimeDetailSlotOpt)="RemoveServiceFilter($event)"
                                ></app-service-duration-price>
                                                 </div>


                        </ng-template>
                      </ngb-panel>

                    </ngb-accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align"
                [disabled]="!addServiceForm.valid" translate><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd
              </button>
              <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em
                  class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>